
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageRozetnijPrzerweOprawa(draggedId,targetId,dropDate,refreshGantAll) {

// id = procesor id
console.log("dropStageRozetnijPrzerweOprawa")
  
  axios
  .get(IP + "API_0010_gant_procedura_rozetnij_przerwe_oprawa/"+draggedId+"/"+targetId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}


